<template>
	<h1>{{ text }}</h1>
</template>

<script>
	export default {
		name: 'Label',
		props: {
            text: String
		}
	}
</script>

<style lang="scss">
h1 {
    margin: 0px;
    background-color: #ecf5ff
}
</style>
